import { render, staticRenderFns } from "./Kinds.vue?vue&type=template&id=e95e6e78"
import script from "./Kinds.vue?vue&type=script&lang=js"
export * from "./Kinds.vue?vue&type=script&lang=js"
import style0 from "./Kinds.vue?vue&type=style&index=0&id=e95e6e78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports